import React, { Component } from 'react';
import { getFactionTextureUrl } from '../Common/TextureTools';

import './choice.css'

import blank1080 from '../Common/blank-1080x210.png';
class FactionIcon extends Component {
    render() {
        let textureUrl;
        let factionId = this.props.factionId;
        textureUrl = getFactionTextureUrl(factionId);
        return <div id={'waiting-for-target'}>
            <img
                src={textureUrl}
                alt="waiting for"
                style={{ width: '16%' }}
            />
        </div>;
    }
}

export default class WaitingFor extends Component {

    render() {
        let gameData = this.props.gameData;
        let activePlayer = gameData.active_player;
        let playerIndex = gameData.gameplayer_set.findIndex(
            gamePlayerData => gamePlayerData.id === activePlayer);
        if (playerIndex < 0) {
            return <></>;
        }
        let gamePlayerData = gameData.gameplayer_set[playerIndex];
        let factionId = gamePlayerData.faction;

        return <div className={'waiting-for-wrapper'}>
            <div className={'waiting-for'}>
                <div>Waiting For {gamePlayerData.seat}-{gamePlayerData.username}</div>
                {factionId && <FactionIcon
                    {...this.props}
                    factionId={factionId}
                />}
            </div>

            <img src={blank1080} alt={'row-background-image'}
                 onClick={this.clickDone}
                 className={'row-background-image'}
            />
        </div>;
    }

}
